import { render, staticRenderFns } from "./printHKJHRSales.vue?vue&type=template&id=3b6970ca&scoped=true&"
import script from "./printHKJHRSales.vue?vue&type=script&lang=js&"
export * from "./printHKJHRSales.vue?vue&type=script&lang=js&"
import style0 from "./printHKJHRSales.vue?vue&type=style&index=0&id=3b6970ca&lang=less&scoped=true&media=print&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6970ca",
  null
  
)

component.options.__file = "printHKJHRSales.vue"
export default component.exports